import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'phoneNumberFormat',
    standalone: true
})
export class PhoneNumberFormatPipe implements PipeTransform {
    transform(phoneNumber: string): string {
        const isDanishPhoneNumber = phoneNumber.match(/^\+45\d{8}$|^\d{8}$/);
        if (!isDanishPhoneNumber) {
            return phoneNumber;
        }
        if (phoneNumber.length === 11) {
            return `${phoneNumber.substr(0, 3)} ${phoneNumber.substr(3, 2)} ${phoneNumber.substr(
                5,
                2
            )} ${phoneNumber.substr(7, 2)} ${phoneNumber.substr(9)}`;
        } else {
            return `${phoneNumber.substr(0, 2)} ${phoneNumber.substr(2, 2)} ${phoneNumber.substr(
                4,
                2
            )} ${phoneNumber.substr(6, 2)}`;
        }
    }
}
